<template>
  <b-form-group
    label="Hesap No"
    label-for="account_code"
  >
    <b-form-input
      id="account_code"
      v-model="dataItem.account_code"
      placeholder="Hesap No"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'AccountCode',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
}
</script>
